import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useAlert } from 'react-alert';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import {
  DatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  },
  stickyColumn: {
    position: 'sticky',
    left: 0,
    background: 'white',
    zIndex: 1
  },
  stickyColumn1: {
    position: 'sticky',
    left: 0,
    background: 'white',
    zIndex: 900,
    minWidth: '200px'
  },
  tableContainer: {
    overflowX: 'auto',
    maxWidth: '100%'
  },
  table: {
    minWidth: 650
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    background: 'white',
    zIndex: 1000,
    minWidth: '200px'
  },
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    left: 0,
    backgroundColor: 'white',
    zIndex: 1000,
    height: '20px'
  },
  totalCell: {
    position: 'sticky',
    bottom: 0,
    left: 0,
    backgroundColor: 'white',
    zIndex: 1000
  },
  subCell: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'white',
    zIndex: 900
  }
}));

const screenCode = 'TC15REPORTSUPPLIERWISE';

export default function TcSummaryReport(props) {
  const [title, setTitle] = useState('TC 15 Supplier Wise Report');
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routes, setRoutes] = useState();
  const [supplierCropdetails, setSupplierCropdetails] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    fromDate: '',
    toDate: ''
  });
  const [supplierCropData, setSupplierCropData] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    monthName: '',
    factoryName: '0',
    routeName: '0',
    groupName: '0'
  });
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const [isViewTable, setIsViewTable] = useState(true);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [isScrollable, setIsScrollable] = useState(false);
  const tableRef = useRef(null);

  const maxDate = new Date(fromDate);
  maxDate.setDate(maxDate.getDate() + 30);

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    const checkScrollable = () => {
      if (tableRef.current) {
        setIsScrollable(tableRef.current.scrollWidth > tableRef.current.clientWidth);
      }
    };

    checkScrollable();
    window.addEventListener("resize", checkScrollable);
    return () => window.removeEventListener("resize", checkScrollable);
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropdown());
    setIsViewTable(true);
  }, [supplierCropdetails.groupID]);

  useEffect(() => {
    trackPromise(getRoutesByFactoryID());
    setIsViewTable(true);
  }, [supplierCropdetails.factoryID]);

  useEffect(() => {
    setIsViewTable(true);
  }, [supplierCropdetails.routeID]);

  useEffect(() => {
    setIsViewTable(true);
  }, [supplierCropdetails.month]);

  useEffect(() => {
    setSupplierCropData([])
 }, [supplierCropdetails.groupID , supplierCropdetails.factoryID, supplierCropdetails.routeID, supplierCropdetails.fromDate,  supplierCropdetails.toDate]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'TC15REPORTSUPPLIERWISE'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setSupplierCropdetails({
      ...supplierCropdetails,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(
      supplierCropdetails.groupID
    );
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(
      supplierCropdetails.factoryID
    );
    setRoutes(routeList);
  }

  async function GetCropDetails() {
    let model = {
      groupID: parseInt(supplierCropdetails.groupID),
      factoryID: parseInt(supplierCropdetails.factoryID),
      routeID: parseInt(supplierCropdetails.routeID),
      fromDate: new Date(fromDate).toISOString(),
      toDate: new Date(toDate).toISOString()
    };

    getSelectedDropdownValuesForReport(model);
    const cropData = await services.GetSummaryDeatailsSupplierWise(model);
    if (cropData.statusCode === 'Success' && cropData.data != null) {
      setIsViewTable(false);

      const merged = cropData.data.reduce((acc, record) => {
        const formattedDate = moment(record.cropCollectedDate).format('YYYY-MM-DD');

        const key = `${record.customerID}`;

        if (!acc[key]) {
          acc[key] = {
            registrationNumber: 0,
            slQuantityTotal: 0,
            nlQuantityTotal: 0,
            total: 0,
            name: '',
            details: []
          }
        }
        if (record.collectionTypeID === null || record.netWeight === '') {
          acc[key].total += record.netWeight;

        }
        if (Number(record.collectionTypeID) === 2) {
          acc[key].slQuantityTotal += Number(record.netWeight);
          acc[key].details.push({
            slQuantity: record.netWeight,
            collectedDate: formattedDate,
            nlQuantity: 0,
          });
        }
        if (Number(record.collectionTypeID) === 1) {
          acc[key].nlQuantityTotal += Number(record.netWeight);
          acc[key].details.push({
            slQuantity: 0,
            collectedDate: formattedDate,
            nlQuantity: record.netWeight,
          });
        }
        acc[key].registrationNumber = record.registrationNumber;
        acc[key].name = record.fullName;

        return acc;
      }, {});

      setSupplierCropData(merged);

      if (cropData.data.length === 0) {
        setIsViewTable(true);
        alert.error('No records to display');
      }
    } else {
      alert.error(cropData.message);
    }
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setSupplierCropdetails({
      ...supplierCropdetails,
      [e.target.name]: value
    });
    setSupplierCropData([]);
  }

  async function createDataForExcel() {
    let result = [];

    let totalRow = {
      registrationNumber: 'Total',
      name: '',
      slTotal: 0,
      nlTotal: 0,
      total: 0
    };

    dateRange.forEach(date => {
      totalRow[`day${date.month}-${date.day}-SL`] = 0;
      totalRow[`day${date.month}-${date.day}-NL`] = 0;
    });

    Object.entries(supplierCropData).forEach(([index, row]) => {
      let newRow = {
        registrationNumber: row.registrationNumber,
        name: row.name,
        slTotal: row.slQuantityTotal || 0,
        nlTotal: row.nlQuantityTotal || 0,
        total: row.total || 0
      };
  
      dateRange.forEach(date => {
        const formattedDate = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
        const matchingRecord = row.details.filter(detail => detail.collectedDate === formattedDate);
        let sl = 0;
        let nl = 0;
        matchingRecord.forEach(rec => {
          if (rec.nlQuantity === 0 && rec.slQuantity !== 0) {
            sl = rec.slQuantity;
          } else if (rec.slQuantity === 0 && rec.nlQuantity !== 0) {
            nl = rec.nlQuantity;
          }
        });
        newRow[`day${date.month}-${date.day}-SL`] = sl;
        newRow[`day${date.month}-${date.day}-NL`] = nl;
  
        totalRow[`day${date.month}-${date.day}-SL`] += sl;
        totalRow[`day${date.month}-${date.day}-NL`] += nl;
      });

        totalRow.slTotal += newRow.slTotal;
        totalRow.nlTotal += newRow.nlTotal;
        totalRow.total += newRow.total;

        result.push(newRow);
    });
    
    result.push(totalRow);

    result.push({});

    result.push({
      registrationNumber: `Group: ${selectedSearchValues.groupName}`,
      name: `Factory: ${selectedSearchValues.factoryName}`,
      slTotal: "",
      nlTotal: "",
      total: ""
    });
    result.push({
      registrationNumber: `Route: ${selectedSearchValues.routeName}`,
      name: `FROM DATE: ${moment(fromDate).format("YYYY/MM/DD")}`,
      slTotal: `TO DATE: ${moment(toDate).format("YYYY/MM/DD")}`,
      nlTotal: "" ,
      total: ""
    });

    return result;
  }

  async function createFile() {
    try {

      let tempcsvHeaders = [
        { label: 'Registration Number', value: 'registrationNumber' },
        { label: 'Name', value: 'name' },
        { label: 'SL Total (/kg)', value: 'slTotal' },
        { label: 'NL Total (/kg)', value: 'nlTotal' },
        { label: 'Total (/kg)', value: 'total' }
      ];

      dateRange.forEach(date => {
        tempcsvHeaders.push({
          label: `${date.month}-${date.day} SL (/kg)`,
          value: `day${date.month}-${date.day}-SL`
        });
        tempcsvHeaders.push({
          label: `${date.month}-${date.day} NL (/kg)`,
          value: `day${date.month}-${date.day}-NL`
        });
      });

      let fileData = await createDataForExcel();

      var settings = {
        sheetName: 'TC 15 Supplier Wise Report',
        fileName: `TC 15 Supplier Wise Report - ${selectedSearchValues.groupName} - ${selectedSearchValues.factoryName} - ${selectedSearchValues.routeName || 'All Routes'} - FROM DATE ${moment(fromDate).format("YYYY/MM/DD")} TO DATE ${moment(toDate).format("YYYY/MM/DD")}`,
        writeOptions: {}
      };

      let dataA = [
        {
          sheet: 'TC 15 Supplier Wise Report',
          columns: tempcsvHeaders,
          content: fileData
        }
      ];

      xlsx(dataA, settings);

    } catch (error) {
      console.error("Error creating Excel file:", error);
    }
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      factoryName: FactoryList[searchForm.factoryID],
      routeName: routes[searchForm.routeID],
      year: searchForm.year,
      groupName: GroupList[searchForm.groupID]
    });
  }

  const getPageMargins = () => {
    return `@media print {
        @page {
            size: A3 Landscape !important;
            margin: 50px 2px 56px 2px !important;
            background-color: white !important;
        }
        body {
            transform: scale(1, 1);
            transform-origin: top left;
            background-color: white !important;
            width: 100%;
        }
    }`;
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }
  const dateRange = (() => {
    const startDate = new Date(fromDate);
    const endDate = new Date(toDate);
    const dateArray = [];
    while (startDate <= endDate) {

      dateArray.push({
        month: startDate.getMonth() + 1,
        day: startDate.getDate(),
        year: startDate.getFullYear()

      });
      startDate.setDate(startDate.getDate() + 1);
    }
    return dateArray;
  })();

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: supplierCropdetails.groupID,
              factoryID: supplierCropdetails.factoryID,
              routeID: supplierCropdetails.routeID,
              toDate: toDate,
              fromDate: fromDate
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number()
                .required('Group is required')
                .min('1', 'Group is required'),
              factoryID: Yup.number()
                .required('Factory is required')
                .min('1', 'Factory is required'),
              routeID: Yup.number()
                .required('Route is required')
                .min('1', 'Route is required'),
              toDate: Yup.date()
                .required('To Date is required')
                .min(Yup.ref('fromDate'), 'To Date cannot be before From Date')
                .test(
                  'within-31-days',
                  'To Date should be within 31 days after From Date',
                  function (value) {
                    const fromDate = this.parent.fromDate;

                    if (!value || !fromDate) return true;
                    const fromDateTime = new Date(fromDate).getTime();
                    const toDateTime = new Date(value).getTime();
                    const diffInDays = (toDateTime - fromDateTime) / (1000 * 60 * 60 * 24);
                    return diffInDays >= 0 && diffInDays <= 30;
                  }
                ),

              fromDate: Yup.date().required('To Date is required'),

            })}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={() => trackPromise(GetCropDetails())}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <Divider />
                    <CardContent>
                      <Grid container spacing={3}>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField
                            select
                            error={Boolean(touched.groupID && errors.groupID)}
                            fullWidth
                            helperText={touched.groupID && errors.groupID}
                            name="groupID"
                            onBlur={handleBlur}
                            onChange={e => handleChange(e)}
                            value={supplierCropdetails.groupID}
                            variant="outlined"
                            id="groupID"
                            size="small"
                            disabled={!permissionList.isGroupFilterEnabled}
                          >
                            <MenuItem value="0">--Select Group--</MenuItem>
                            {generateDropDownMenu(GroupList)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="factoryID">
                            Factory *
                          </InputLabel>
                          <TextField
                            select
                            error={Boolean(
                              touched.factoryID && errors.factoryID
                            )}
                            fullWidth
                            helperText={touched.factoryID && errors.factoryID}
                            name="factoryID"
                            onBlur={handleBlur}
                            onChange={e => handleChange(e)}
                            value={supplierCropdetails.factoryID}
                            variant="outlined"
                            id="factoryID"
                            size="small"
                            disabled={!permissionList.isFactoryFilterEnabled}
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateDropDownMenu(FactoryList)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="routeID">
                            Route *
                          </InputLabel>
                          <TextField
                            select
                            error={Boolean(touched.routeID && errors.routeID)}
                            fullWidth
                            helperText={touched.routeID && errors.routeID}
                            name="routeID"
                            onChange={e => handleChange(e)}
                            value={supplierCropdetails.routeID}
                            variant="outlined"
                            id="routeID"
                            size="small"
                          >
                            <MenuItem value="0">--Select Route--</MenuItem>
                            {generateDropDownMenu(routes)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                              autoOk
                              variant="inline"
                              label="From Date *"
                              helperText={touched.fromDate && errors.fromDate}
                              error={Boolean(touched.fromDate && errors.fromDate)}
                              value={fromDate}
                              onChange={(date) => {
                                setFromDate(date);
                                setSupplierCropData([]);
                              }}
                              format="MM/dd/yyyy"
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                              autoOk
                              variant="inline"
                              label="To Date *"
                              helperText={touched.toDate && errors.toDate}
                              error={Boolean(touched.toDate && errors.toDate)}
                              value={toDate}
                              onChange={(date) => {
                                setToDate(date);
                                setSupplierCropData([]);
                              }}
                              format="MM/dd/yyyy"
                              minDate={fromDate}
                              maxDate={maxDate}
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                      </Grid>
                      <Box display="flex" flexDirection="row-reverse" p={2}>
                        <Button
                          color="primary"
                          type="submit"
                          variant="contained"
                          size="small"
                        >
                          Search
                        </Button>
                      </Box>
                      <Box minWidth={1000} hidden={isViewTable}>
                        {Object.keys(supplierCropData).length > 0 ? (
                          <TableContainer style={{ maxHeight: "550px", overflow: "auto", border: "1px solid black",}}>
                            <Table aria-label="caption table" stickyHeader >
                              <TableHead style={{border: "1px solid black",}}>
                                <TableRow style={{ position: "sticky", top: 0, zIndex: 1000, backgroundColor: "white",}}>
                                  <TableCell
                                    style={{
                                      border: "1px solid black",borderBottom: "none",fontWeight: "bold",fontSize: "13px",position: "sticky",top: 0,left: 0,zIndex: 1000,minWidth: "150px",backgroundColor: "white"
                                    }}align="left">
                                    Registration Number
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      position: "sticky", top: 0, left: 150, zIndex: 1000, minWidth: "250px",border: "1px solid black",borderBottom: "none",fontWeight: "bold",fontSize: "13px",backgroundColor: "white"
                                    }}align="left">
                                    Name
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      position: "sticky", border: "1px solid black",minWidth: "100px", borderBottom: "none",fontWeight: "bold",fontSize: "13px", top: 0, left: 400, zIndex: 1000,backgroundColor: "white"
                                    }}align="left" >
                                    SL Total
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      position: "sticky",border: "1px solid black",minWidth: "100px",borderBottom: "none",fontWeight: "bold",fontSize: "13px",zIndex: 1000,top: 0, left: 500, backgroundColor: "white"
                                    }}align="left">
                                    NL Total
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      position: "sticky", border: "1px solid black",minWidth: "100px",borderBottom: "none",fontWeight: "bold",fontSize: "13px",top: 0,zIndex: 100, left: 600, backgroundColor: "white"
                                    }} align="left">
                                    Total
                                  </TableCell>

                                  {dateRange.map((date, index) => {
                                    return (
                                      <TableCell
                                        key={index}
                                        className={`${classes.stickyHeader, classes.stickyColumn}`}
                                        style={{
                                          border: "1px solid black",fontWeight: "bold",fontSize: "13px",
                                        }}align="center"colSpan={2}
                                      >
                                        {date.month}-{date.day}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    style={{
                                      border: "1px solid black",borderTop: "none", fontWeight: "bold", fontSize: "13px", position: "sticky", left: 0, minWidth: "150px", backgroundColor: "white", top: 80, zIndex: 1000,
                                    }}align="left"
                                  ></TableCell>
                                  <TableCell
                                    style={{
                                      position: "sticky",left: 150,minWidth: "250px",border: "1px solid black",borderTop: "none",fontWeight: "bold",fontSize: "13px",backgroundColor: "white", top: 80, left: 150, zIndex: 1000, minWidth: "250px",
                                    }}
                                  ></TableCell>
                                  <TableCell
                                    style={{
                                      border: "1px solid black",borderTop: "none",fontWeight: "bold",fontSize: "13px",position: "sticky",backgroundColor: "white",zIndex: 1000, top: 80, minWidth: "100px", left: 400
                                    }}align="left">
                                    /kg
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      border: "1px solid black",borderTop: "none",fontWeight: "bold",fontSize: "13px",position: "sticky", backgroundColor: "white", top: 80, minWidth: "100px", left: 500, zIndex: 1000
                                    }}align="left">
                                    /kg
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      border: "1px solid black",borderTop: "none",fontWeight: "bold",fontSize: "13px",position: "sticky",backgroundColor: "white", top: 80, minWidth: "100px", left: 600, zIndex: 1000
                                    }}align="left">
                                    /kg
                                  </TableCell>

                                  {dateRange.map((date, index) => {
                                    return (
                                      <>
                                        <TableCell
                                          style={{
                                            border: "1px solid black",
                                            fontWeight: "bold",
                                            fontSize: "13px",
                                            backgroundColor: "white",
                                            top: 80,
                                          }}
                                          className={`${classes.stickyHeader, classes.stickyColumn}`}
                                          align="center"
                                        >
                                          SL
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            border: "1px solid black",
                                            fontWeight: "bold",
                                            fontSize: "13px",
                                            backgroundColor: "white",
                                            top: 80,
                                          }}
                                          className={`${classes.stickyHeader, classes.stickyColumn}`}
                                          align="center"
                                        >
                                          NL
                                        </TableCell>
                                      </>
                                    );
                                  })}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {Object.entries(supplierCropData).map(([index, row]) => {
                                  return (
                                    <TableRow key={index}>
                                      <TableCell style={{border: "1px solid black",fontSize: "13px",position: "sticky",left: 0, minWidth: "150px",backgroundColor: "white", zIndex: 900}} align="left">
                                        {row.registrationNumber}
                                      </TableCell>
                                      <TableCell style={{position: "sticky", left: 150, backgroundColor: "white",border: "1px solid black",fontSize: "13px",minWidth: "250px", zIndex: 900}} align="left">
                                        {row.name}
                                      </TableCell>
                                      <TableCell style={{ position: "sticky", border: "1px solid black", fontSize: "13px", padding: 0, backgroundColor: "white", textAlign: row.slQuantity === 0 ? "center" : "right", minWidth: "100px", left: 400, zIndex: 900}}>
                                        {row.slQuantity === 0 ? "-" : Number(row.slQuantityTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </TableCell>
                                      <TableCell style={{ position: "sticky", border: "1px solid black", fontSize: "13px", padding: 0, backgroundColor: "white", textAlign: row.nlQuantity === 0 ? "center" : "right",minWidth: "100px", left: 500, zIndex: 900}}>
                                        {row.slQuantity === 0 ? "-" : Number(row.nlQuantityTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </TableCell>
                                      <TableCell style={{ position: "sticky", border: "1px solid black", fontSize: "13px", padding: "10px", backgroundColor: "white", textAlign: row.total === 0 ? "center" : "right", minWidth: "100px", left: 600, zIndex: 900}}>
                                        {row.slQuantity === 0 ? "-" : Number(row.total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </TableCell>
                                      {dateRange.map((date, index) => {
                                        const formattedDate = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
                                        const matchingRecord = row.details.filter((detail) =>
                                          detail.collectedDate === formattedDate
                                        );

                                        const array = [];
                                        matchingRecord.forEach((rec, i) => {
                                          if (rec.nlQuantity === 0) {
                                            array.push({
                                              slQuantity: rec.slQuantity
                                            })
                                          } else if (rec.slQuantity === 0) {
                                            array.push({
                                              nlQuantity: rec.nlQuantity
                                            })
                                          }
                                        })

                                        const slEntry = array.find(item => item.hasOwnProperty('slQuantity'));
                                        const nlEntry = array.find(item => item.hasOwnProperty('nlQuantity'));
                                        const sl = slEntry ? slEntry.slQuantity : null;
                                        const nl = nlEntry ? nlEntry.nlQuantity : null;

                                        return (
                                          <React.Fragment key={index}>
                                            <TableCell style={{ border: "1px solid black", fontSize: "13px", padding: 0, zIndex: 900, }} align={sl === null ? "center" : "right"}>
                                              {Number(sl) === 0 ? "-" : Number(sl).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell style={{ border: "1px solid black", fontSize: "13px", padding: 0, zIndex: 900, }} align={nl === null ? "center" : "right"} >
                                              {Number(nl) === 0 ? "-" : Number(nl).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                          </React.Fragment>
                                        );
                                      })}
                                    </TableRow>
                                  );
                                })}
                                <TableRow>
                                  <TableCell style={{border: "1px solid black",fontWeight: "bold",fontSize: "13px",position: "sticky", top: 0, left: 0,zIndex: 12, backgroundColor: "white", minWidth: "150px",}} align="left">
                                    Total
                                  </TableCell>
                                  <TableCell style={{ position: "sticky",top: 0, left: 150, zIndex: 12,backgroundColor: "white",border: "1px solid black",fontWeight: "bold",fontSize: "13px",minWidth: "250px"}} align="left">
                                  </TableCell>
                                  <TableCell style={{ position: "sticky", border: "1px solid black", left: 400, zIndex: 12, backgroundColor: "white", fontWeight: "bold", fontSize: "13px", padding: 0, minWidth: "100px", }} align="right">
                                    {Object.entries(supplierCropData)
                                      .reduce((sum, [, row]) => sum + (row.slQuantityTotal || 0), 0)
                                      .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </TableCell>
                                  <TableCell style={{ position: "sticky", border: "1px solid black", left: 500, zIndex: 12, backgroundColor: "white",  fontWeight: "bold", fontSize: "13px", padding: 0, minWidth: "100px", }} align="right">
                                    {Object.entries(supplierCropData)
                                      .reduce((sum, [, row]) => sum + (row.nlQuantityTotal || 0), 0)
                                      .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </TableCell>
                                  <TableCell style={{ position: "sticky", border: "1px solid black",left: 600, zIndex: 12, backgroundColor: "white", fontWeight: "bold", fontSize: "13px", padding: "10px", minWidth: "100px", }} align="right">
                                    {Object.entries(supplierCropData)
                                      .reduce((sum, [, row]) => sum + (row.total || 0), 0)
                                      .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </TableCell>

                                  {dateRange.map((date, index) => {
                                    const formattedDate = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;

                                      let totalSlQuantity = 0;
                                      let totalNlQuantity = 0;

                                      Object.values(supplierCropData).forEach((row) => {
                                        if (row.details) {
                                          row.details.forEach((detail) => {
                                            if (detail.collectedDate === formattedDate) {
                                              totalSlQuantity += Number(detail.slQuantity) || 0;
                                              totalNlQuantity += Number(detail.nlQuantity) || 0;
                                            }
                                          });
                                        }
                                      });

                                    return (
                                      <React.Fragment key={index}>
                                        <TableCell style={{ position: "sticky", border: "1px solid black", fontWeight: "bold", fontSize: "13px", padding: 0, zIndex: 11 }} align={totalSlQuantity === 0 ? "center" : "right"}>
                                          {totalSlQuantity === 0 ? "-" : Number(totalSlQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell style={{ position: "sticky", border: "1px solid black", fontWeight: "bold", fontSize: "13px", padding: 0, zIndex: 11 }} align={totalNlQuantity === 0 ? "center" : "right"}>
                                          {totalNlQuantity === 0 ? "-" : Number(totalNlQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                      </React.Fragment>
                                    );
                                  })}
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                         ) : null}
                      </Box>
                    </CardContent>
                    <br />
                    <Divider />
                    {Object.keys(supplierCropData).length > 0 &&
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          color="primary"
                          id="btnRecord"
                          type="submit"
                          variant="contained"
                          style={{ marginRight: '1rem' }}
                          className={classes.colorRecord}
                          onClick={() => createFile()}
                          size="small"
                        >
                          EXCEL
                        </Button>
                        <ReactToPrint
                          documentTitle={
                            'TC 15 Supplier Wise Report' + ' - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' - ' + (selectedSearchValues.routeName ? selectedSearchValues.routeName : 'All Routes') + ' -  from:' +
                            moment(fromDate).format("YYYY-MM-DD") + ' To:' + moment(toDate).format("YYYY-MM-DD")
                          }
                          trigger={() => (
                            <Button
                              color="primary"
                              id="btnRecord"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                              size="small"
                            >
                              PDF
                            </Button>
                          )}
                          pageStyle={getPageMargins()}
                          content={() => componentRef.current}
                        />
                        <div hidden={true}>
                          <CreatePDF
                            ref={componentRef}
                            supplierCropData={supplierCropData}
                            selectedSearchValues={selectedSearchValues}
                            dateRange={dateRange}
                            fromDate = {fromDate}
                            toDate =  {toDate}
                          />
                        </div>
                      </Box>
                    }
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
